import {i18n} from '@netx/core/i18n';
import type {ServerError} from '@netx/core/typings';

export const CATEGORY_ERROR_CODE = <const>{
	NAME_CONFLICT: 301,
	OBJECT_NOT_FOUND: 4003,
	USER_CANNOT_RESTRICT_SELF_ACCESS: 10027,
};

export const CATEGORY_ERRORS: ServerError<typeof CATEGORY_ERROR_CODE> = <const>{
	// for the moment
	// @ts-ignore
	[CATEGORY_ERROR_CODE.NAME_CONFLICT]: {
		code: CATEGORY_ERROR_CODE.NAME_CONFLICT,
		message: `Validation error (The Name chosen conflicts with another category with the same name in the same category)`,
		translated: i18n.t(
			`i18n.categoryError_${CATEGORY_ERROR_CODE.NAME_CONFLICT}`,
		),
	},
	[CATEGORY_ERROR_CODE.USER_CANNOT_RESTRICT_SELF_ACCESS]: {
		code: CATEGORY_ERROR_CODE.USER_CANNOT_RESTRICT_SELF_ACCESS,
		message: `Action would restrict caller access`,
		translated: i18n.t(
			`i18n.categoryError_${CATEGORY_ERROR_CODE.USER_CANNOT_RESTRICT_SELF_ACCESS}`,
		),
	},
	[CATEGORY_ERROR_CODE.OBJECT_NOT_FOUND]: {
		code: CATEGORY_ERROR_CODE.OBJECT_NOT_FOUND,
		message: `Object not found (invalid category_id (<id>))`,
		translated: i18n.t(
			`i18n.categoryError_${CATEGORY_ERROR_CODE.OBJECT_NOT_FOUND}`,
		),
	},
};

export default CATEGORY_ERRORS;
